"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressStatic = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _any = _interopRequireDefault(require("lodash/fp/any"));
var _trim = _interopRequireDefault(require("lodash/fp/trim"));
var _negate = _interopRequireDefault(require("lodash/fp/negate"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _interpolate = _interopRequireDefault(require("interpolate"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _parseForRender = _interopRequireDefault(require("../utils/parseForRender"));
var _formats = _interopRequireDefault(require("../configs/formats"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_TEMPLET = '{address.line1}\n{address.line2}\n{address.city}, {address.stateProvince}\n{address.postalCode}\n{address.country}';
function localizeCountry(countryCode, i18n) {
  var key = "country.displayName.".concat(countryCode);
  var message = i18n(key);
  return message === key ? countryCode : message;
}
function localizeStateProvince(countryCode, stateProvinceCode, i18n) {
  if (!stateProvinceCode) {
    return null;
  }
  var key = "stateProvince.displayName.".concat(countryCode, ".").concat(stateProvinceCode);
  var message = i18n(key);
  return message === key ? stateProvinceCode : message;
}
function parseAddress(address) {
  return _objectSpread(_objectSpread({}, address), {}, {
    stateProvince: address.stateProvince === address.country ? null : address.stateProvince
  });
}
function localizeAddress(address, i18n) {
  return _objectSpread(_objectSpread({}, address), {}, {
    country: localizeCountry(address.country, i18n),
    stateProvince: localizeStateProvince(address.country, address.stateProvince, i18n)
  });
}
function formatAddress(format, address) {
  return format.split('\n').map(function (fields) {
    return fields.split(',').map(function (field) {
      return (0, _interpolate["default"])(field, {
        address: address
      }).replace(/\{.*\}|null|undefined/g, '');
    }).filter(function (field) {
      return !!field.trim();
    }).join(',').trim();
  }).filter(function (field) {
    return field;
  });
}
var isEmptyString = (0, _compose["default"])(_isEmpty["default"], _trim["default"]);
var nonEmptyAddress = (0, _compose["default"])((0, _any["default"])((0, _negate["default"])(isEmptyString)), Object.values);
/**
 * Format an address into static string.
* */
var AddressStatic = exports.AddressStatic = function AddressStatic(_ref) {
  var i18n = _ref.i18n,
    _ref$nowrap = _ref.nowrap,
    nowrap = _ref$nowrap === void 0 ? false : _ref$nowrap,
    _ref$countriesFormatC = _ref.countriesFormatConfig,
    countriesFormatConfig = _ref$countriesFormatC === void 0 ? {} : _ref$countriesFormatC,
    address = _ref.address;
  var parsedAddress = (0, _compose["default"])(parseAddress, _parseForRender["default"])(address);
  var config = _objectSpread(_objectSpread({}, _formats["default"]), countriesFormatConfig);
  var template = config[parsedAddress.country] || DEFAULT_TEMPLET;
  var El = nowrap ? 'span' : 'div';
  var fields = nonEmptyAddress(parsedAddress) ? formatAddress(template, localizeAddress(parsedAddress, i18n)) : [];
  return /*#__PURE__*/_react["default"].createElement(El, null, fields.map(function (f, i) {
    return /*#__PURE__*/_react["default"].createElement(El, {
      key: f
    }, f, nowrap && i < fields.length - 1 ? ', ' : '');
  }));
};
var _default = exports["default"] = (0, _LocaleContext.withI18n)(AddressStatic);